<template>
  <section class="article-detail-page">
    <div class="article-detail-box">
      <div class="container">
        <div class="back-article" style="padding-left:0px" @click="goBackArticle()"><label class="icon iconfont">&#xe601; </label>返回文章列表</div>
        <div class="row container-padding">
          <div class="col-xs-12 col-sm-12 col-md-12 ad-box-border">
            <p class="article-detail-title">{{article.title}}</p>
            <p class="article-detail-author">{{article.author}}</p>
            <p class="article-detail-time">{{article.createDate}}</p>
            <p class="copy-link" :class="copyText=='复制成功'?'copy-link-active':''" v-clipboard:copy="pageurl" v-clipboard:success="onCopy">{{copyText}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="container container-content container-padding">
      <div class="article-detail-content">
        <img v-if="article.image" :src="article.image" style="width:100%" alt="" class="img-responsive">
        <p>{{article.content}}</p>
      </div>
    </div>
  </section>
</template>

<script>
document.onselectstart = new Function("event.returnValue=false;"); //禁止选择,也就是无法复制
export default {
  name: 'articleDetail', //不能删，此时用于keep-alive生效
	data () {
		return {
      article: {
        title: '',
        author: '',
        content: '',
        createDate: '',
        image: ''
      },
      copyText: '复制链接',
      pageurl: window.location.href
		}
	},
  mounted () {
			this.axios.get('https://sys.qilinsports.com/law/sysarticle/'+this.$route.query.id).then((res) => {
				if (res.data.code == 0) {
          this.article = res.data.data
          console.log(article)
				}
			}).catch(function(error){
				console.log(error)//错误处理 相当于error
			})
  },
  methods: {
    onCopy () {
      this.copyText = '复制成功'
      setTimeout(()=>{
        this.copyText = "复制链接"
      },600)
    },
    goBackArticle () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
@import url("../assets/css/common.css");
@import url("../assets/css/product.css");
.section-active {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/article-detail.vue